export default "__VITE_ASSET__Bw38opsA__"